import { Api } from '@/api/api.client';
import { Components } from '../generated/api';

export async function fetchGrowthCta(): Promise<Components.Schemas.GrowthPopupType> {
  const res = await Api.Routes.Growth.getCta();
  return res.data.popup;
}

export async function fetchGrowthState(): Promise<Components.Schemas.GrowthStateDto> {
  const res = await Api.Routes.Growth.getState();
  return res.data;
}

export async function dismissGrowthPopup(popup: Components.Schemas.GrowthPopupType): Promise<void> {
  await Api.Routes.Growth.dismissPopup(null, { popup });
}
